import products from './products';
import cart from './cart';
import orders from './orders';
import shipping from './shipping';
import shippingCosts from './shippingCosts';
import productPayment from './productPayment';
import nav from './nav';
import aboutUs from './aboutUs';
import landing from './landing';
import trips from './trips';
import tripDetails from './tripDetails';
import common from './common';
import account from './account';
import payment from './payment';
import destinationDetails from './destinationDetails';
import contact from './contact';
import auth from './auth';
import booking from './booking';
import destinations from './destinations';
import activities from './activities';
import curiosities from './curiosities';
import itinerary from './itinerary';

export const nl = {
    products,
    cart,
    orders,
    shipping,
    shippingCosts,
    productPayment,
    nav,
    aboutUs,
    landing,
    trips,
    tripDetails,
    common,
    account,
    payment,
    destinationDetails,
    contact,
    auth,
    booking,
    destinations,
    activities,
    curiosities,
    itinerary
};

export default nl;

